import {
  productColorName,
  productColorBackground,
  CABLE_COLOR_HEX
} from '../../helpers/productColor';

// Readable black/white text on a colour swatch (luminance-based).
const textOn = name => {
  const hex = CABLE_COLOR_HEX[String(name || '').trim().toUpperCase()];
  if (!hex || hex.length < 7) return '#fff';
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return 0.299 * r + 0.587 * g + 0.114 * b > 150 ? '#111' : '#fff';
};

// A small, pretty pill showing a product's real (sheath / wire) colour with its name —
// the same swatch used in the create-order Color column. Pass an explicit `colorName`
// (for order-line rows whose `.color` is the product colour) or a `row` (job / bobin
// row — colour derived from its productKey / productColor). Renders an em-dash when no
// colour can be resolved.
const ColorLabel = ({ row, colorName, size = 'sm', className = '', style = {} }) => {
  const name = (colorName || productColorName(row) || '').trim().toUpperCase();
  if (!name) return <span className="text-muted">—</span>;

  const pad = size === 'sm' ? '0.2em 0.6em' : '0.28em 0.75em';
  const fontSize = size === 'sm' ? '0.7rem' : '0.78rem';

  return (
    <span
      title={name}
      className={`badge rounded-pill fw-semibold ${className}`}
      style={{
        background: productColorBackground(name),
        color: textOn(name),
        border: '1px solid rgba(0,0,0,0.15)',
        padding: pad,
        fontSize,
        whiteSpace: 'nowrap',
        ...style
      }}
    >
      {name}
    </span>
  );
};

export default ColorLabel;
